// Demo data in the real device format (raw ADC accel, gyro deg/s, unix-second timestamps, ~2 Hz).
const noise = () => (Math.random() - 0.5) * 2;
const BASE = { x: 1864, y: 1858, z: 2281 };

export function genTest(isGood, startSec, sampleCount) {
  const pts = [];
  const durationSec = sampleCount / 2;
  const sectionLength = Math.floor(sampleCount / 4);
  for (let i = 0; i < sampleCount; i++) {
    const section = Math.floor(i / sectionLength);
    const pos = i % sectionLength;
    const inTurn = section < 4 && pos >= 1 && pos <= 3;
    // Figure 8: RIGHT, LEFT, RIGHT, LEFT. Positive gyroZ = LEFT. Bad riders swap the 3rd turn.
    let dir = section % 2 === 0 ? -1 : 1;
    if (!isGood && section === 2) dir = 1;
    const rate = isGood ? 40 : 110;
    const wobble = isGood ? 2 : 35;
    const shake = isGood ? 8 : 70;
    pts.push({
      accelX: Math.round(BASE.x + noise() * shake + (inTurn ? dir * (isGood ? 20 : 90) : 0)),
      accelY: Math.round(BASE.y + noise() * shake),
      accelZ: Math.round(BASE.z + noise() * shake),
      gyroX: +(noise() * wobble).toFixed(5),
      gyroY: +(noise() * wobble).toFixed(5),
      gyroZ: +(inTurn ? dir * rate + noise() * 4 : noise() * 1.5).toFixed(5),
      magX: +(9 + noise() * (isGood ? 0.5 : 2)).toFixed(2),
      magY: +(-30 + noise() * (isGood ? 0.5 : 2)).toFixed(2),
      magZ: +(48 + noise() * (isGood ? 0.5 : 2)).toFixed(3),
      timestamp: startSec + Math.floor(i / 2),
    });
  }
  return {
    sensorData: pts,
    start: startSec,
    stop: startSec + Math.ceil(durationSec),
    durationMs: Math.round(durationSec * 1000),
    durationSeconds: durationSec,
    sampleCount,
    status: "completed",
  };
}

export const DEMO_TESTS = [
  { id: "TEST-001", name: "Rahul Sharma", age: 22, vehicle: "Honda Activa 6G", center: "Andheri RTO, Mumbai", good: true, sampleCount: 48 },
  { id: "TEST-002", name: "Priya Patel", age: 19, vehicle: "TVS Jupiter", center: "Andheri RTO, Mumbai", good: true, sampleCount: 44 },
  { id: "TEST-003", name: "Sneha Kulkarni", age: 21, vehicle: "Honda Dio", center: "Pune Camp RTO", good: true, sampleCount: 52 },
  { id: "TEST-004", name: "Amit Deshmukh", age: 25, vehicle: "Bajaj Pulsar 150", center: "Pune Camp RTO", good: false, sampleCount: 46 },
  { id: "TEST-005", name: "Vikram Singh", age: 30, vehicle: "Royal Enfield 350", center: "Karol Bagh RTO, Delhi", good: false, sampleCount: 40 },
  { id: "TEST-006", name: "Ananya Mishra", age: 20, vehicle: "Suzuki Access 125", center: "Lucknow RTO", good: true, sampleCount: 50 },
  { id: "TEST-007", name: "Karan Joshi", age: 27, vehicle: "Yamaha FZ-S", center: "Baner RTO, Pune", good: false, sampleCount: 56 },
  { id: "TEST-008", name: "Meera Nair", age: 24, vehicle: "TVS Ntorq", center: "Kochi RTO, Kerala", good: true, sampleCount: 44 },
  { id: "TEST-009", name: "Rohan Gupta", age: 28, vehicle: "Hero Splendor", center: "Noida RTO, UP", good: true, sampleCount: 54 },
  { id: "TEST-010", name: "Deepak Yadav", age: 32, vehicle: "KTM Duke 200", center: "Karol Bagh RTO, Delhi", good: false, sampleCount: 48 },
];
